export default __webpack_public_path__ + "static/media/ainstein-icon.f724fb96.svg";